import React, { FC, RefObject } from 'react'
import { ArticleTextProps } from '@sport1/types/web'
import useTheme from '@sport1/react-elements/useTheme'
import darkFontColors from '@sport1/news-styleguide/darkFontColors'
import lightFontColors from '@sport1/news-styleguide/lightFontColors'
import { sport1CondensedBlackItalic, sport1Bold } from '@/helpers/fonts'

type Props = {
    content: ArticleTextProps
    innerRef?: RefObject<HTMLDivElement>
    onClick?: () => void
    followLinks?: boolean
}

const ArticleText: FC<Props> = ({ content, innerRef, onClick, followLinks }) => {
    const { fontColors } = useTheme() as {
        fontColors: typeof darkFontColors | typeof lightFontColors
    }
    if (followLinks && content.text.includes('nofollow')) {
        content.text = content.text.replaceAll(' rel="nofollow"', '')
    }
    return (
        <>
            <div
                className="article-text mb-6 mx-[12px] tn:mx-[24px] sm:mx-[36px]"
                data-testid="article-text"
                ref={innerRef}
                dangerouslySetInnerHTML={{ __html: content.text }}
                onClick={onClick}
            />
            <style jsx global>{`
                .article-text {
                    font-size: 20px;
                    line-height: 26px;
                }
                .article-text a {
                    text-decoration: underline;
                    color: ${fontColors['font-brand-primary']};
                }
                .article-text a:hover {
                    opacity: 0.7;
                }
                .article-text h2 {
                    font-size: 24px;
                    font-family: ${sport1Bold.style.fontFamily}, sans-serif;
                    color: #000;
                    line-height: 32px;
                }
                .article-text strong *,
                .article-text h4,
                .article-text h3 {
                    font-family: Sport1-Bold, sans-serif;
                }
                .article-text i {
                    font-style: italic;
                }
                .article-text h2 i {
                    font-style: italic;
                    font-family: ${sport1CondensedBlackItalic.style.fontFamily}, sans-serif;
                }
                .article-text b {
                    font-weight: bold;
                }
            `}</style>
        </>
    )
}

export default ArticleText
